(function (global) {
  
  /**
  * Функции отвечающие за работу пенелей инструментов
  * @namespace Core.toolbars
  * @since 5.0.0.4102
  */
  global.toolBars = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Функции отвечающие за работу панель инструментов (риббона) в проводнике.
  * @namespace Core.toolbars.main
  * @since 5.0.0.4102
  */
  global.toolBars.main = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Функции отвечающие за работу панели списка объектов.
  * @namespace Core.toolbars.objectList 
  * @since 5.1.0.1505
  */
  global.toolBars.objectList = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Функции отвечающие за работу панель инструментов (риббона) в справочнике.
  * @namespace Core.toolbars.reference
  * @since 5.0.0.4200
  */
  global.toolBars.reference = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  /**
  * Функции отвечающие за работу панель инструментов (риббона) в карточке задания.
  * @namespace Core.toolbars.job
  * @since 5.2.0.1500
  */
  global.toolBars.job = {};
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.Core);